<script>
import ItineraryIncludeWrapper from '../../components/itinerary/ItineraryIncludeWrapper';

export default {
  name: 'ItineraryEditIncludeNot',
  components: {
    ItineraryIncludeWrapper,
  },
};
</script>

<template>
  <div>
    <itinerary-include-wrapper
      include-not
      title="Not included"
    />
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/itinerary/ItineraryEditIncludeNot.vue